import { useEffect, useState } from 'react'
import { ArrowUpRight, Menu, MessageCircle, X } from 'lucide-react'
import { Link, NavLink, Outlet, useLocation } from 'react-router-dom'
import logo from '../../assets/logo_clg.png'
import logoSmall from '../../assets/logo_clg_small.png'

const nav = [
  ['Soluções', '/solucoes'], ['Games', '/games'], ['Planos', '/planos'], ['Advergames', '/advergames'], ['Casos', '/casos'], ['Insights', '/insights'], ['Sobre', '/sobre'],
]

export function Layout() {
  const [open, setOpen] = useState(false)
  const location = useLocation()
  useEffect(() => {
    setOpen(false)
    if (location.hash) {
      window.setTimeout(() => document.querySelector(location.hash)?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 40)
    } else {
      window.scrollTo({ top: 0, behavior: 'instant' })
    }
  }, [location.pathname, location.hash])

  return (
    <>
      <header className={location.pathname === '/' ? 'site-header home-header' : 'site-header'}>
        <Link id="brand-target" to="/" className="brand" aria-label="CLG — página inicial"><img className="brand-full" src={logo} alt="Criative Land Games" /><img className="brand-small" src={logoSmall} alt="Criative Land Games" /></Link>
        <button className="menu-button" onClick={() => setOpen(!open)} aria-expanded={open} aria-label="Abrir menu">{open ? <X /> : <Menu />}</button>
        <nav className={open ? 'nav open' : 'nav'} aria-label="Navegação principal">
          {nav.map(([label, path]) => <NavLink key={path} to={path}>{label}</NavLink>)}
          <Link className="button button-small" to="/contato">Pedir proposta <ArrowUpRight size={16} /></Link>
        </nav>
      </header>
      <main id="conteudo"><Outlet /></main>
      <a className="whatsapp-float" href="https://wa.me/5583991884675?text=Olá%2C%20quero%20conhecer%20o%20CLG" target="_blank" rel="noreferrer" aria-label="Falar pelo WhatsApp"><MessageCircle /></a>
      <footer className="footer">
        <div className="footer-main">
          <div><div className="brand brand-footer"><img src={logo} alt="Criative Land Games" /></div><p>Experiências jogáveis de marca.<br />Criadas em Campina Grande para aproximar o físico e o digital.</p></div>
          <div><strong>Explore</strong>{nav.slice(0, 4).map(([l,p]) => <Link key={p} to={p}>{l}</Link>)}</div>
          <div><strong>Conteúdo</strong>{nav.slice(4).map(([l,p]) => <Link key={p} to={p}>{l}</Link>)}</div>
          <div><strong>Contato</strong><a href="tel:+5583991884675">(83) 99188-4675</a><a href="mailto:vitrinecriativadigitalbrasil@gmail.com">vitrinecriativadigitalbrasil@gmail.com</a></div>
        </div>
        <div className="footer-bottom"><span>© 2026 Criative Land Games</span><span>Produto apoiado pelo Selo Criativo de Artes Midiáticas de Campina Grande.</span></div>
      </footer>
    </>
  )
}
